import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { IFooterMenuItem } from '@/interfaces';
import { getMasterTranslationLanguageCode } from '@/utils';
import Link from 'next/link';
import type React from 'react';
import { Fragment } from 'react';
import { PageLink, PageLinkSeparator, PageLinksWrapper } from './PageLinks.styles';

interface IPageLinksProps {
  pageLinks: IFooterMenuItem[];
  onLinkClick: (href?: string) => void;
  isOpenInNewTab: (href?: string) => '_blank' | undefined;
}

const PageLinks: React.FC<IPageLinksProps> = ({ pageLinks, onLinkClick, isOpenInNewTab }) => {
  const { pmtCurrentLanguageCode } = useGlobalState();
  const languageField = getMasterTranslationLanguageCode(pmtCurrentLanguageCode);

  return (
    <PageLinksWrapper>
      {pageLinks.map(({ title, url }, index) => {
        const isNotLastItem = index !== pageLinks?.length - 1;

        return (
          <Fragment key={index}>
            <Link href={url || '#'} passHref legacyBehavior>
              <PageLink target={isOpenInNewTab(url)} onClick={() => onLinkClick(url)}>
                <Typography type='span' variant={TextStyles['Body Text Small']}>
                  {typeof title === 'string' ? title : title?.[languageField]}
                </Typography>
              </PageLink>
            </Link>
            {isNotLastItem && <PageLinkSeparator />}
          </Fragment>
        );
      })}
    </PageLinksWrapper>
  );
};

export default PageLinks;
